import tracer from 'dd-trace';

tracer.init();
export default tracer;
